exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.info-container[data-v-e18ae9d8]{\n    border: 1px solid #DEDEDE !important;\n    padding-top: 0.125rem;\n    padding-bottom: 0.125rem;\n}\n", ""]);

// exports
